import React, { useState } from 'react';

export const CollapsibleSection = ({ title, icon, children, defaultOpen = false, badge = null, badgeColor = "blue" }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex items-center justify-between bg-gradient-to-r from-gray-50 to-white hover:from-gray-100 hover:to-gray-50 transition-all"
      >
        <div className="flex items-center gap-2">
          <span className="text-xl">{icon}</span>
          <span className="font-semibold text-gray-800">{title}</span>
          {badge && (
            <span className={`px-2 py-0.5 text-xs rounded-full bg-${badgeColor}-100 text-${badgeColor}-700`}>
              {badge}
            </span>
          )}
        </div>
        <span className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}>
          ▼
        </span>
      </button>
      {isOpen && (
        <div className="p-4 border-t border-gray-100">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
